import controller from './bill-info-edit.controller';

export default {
  bindings: {
    invoice: '<',
    packet: '<'
  },
  controller,
  template: require('./bill-info-edit.html')
};



// WEBPACK FOOTER //
// src/app/buy/bill-info/edit/bill-info-edit.component.ts